

$('#btn').click(function() {
	
var brand = $('#brand option:selected').val();
brand = "brand_"+brand;
var tall = $('#tall option:selected').val();
tall = "tall"+tall;
var weight = $('#weight option:selected').val();
weight = "weight"+weight;

$("html,body").animate({scrollTop:$("#"+brand).offset().top});
$("#"+brand+" #"+tall+weight).addClass("thissize");
$("#"+brand+" ."+tall).addClass("thisselect");
$("#"+brand+" ."+weight).addClass("thisselect");

});

/*フォームリセット*/
$("#clearform").click(function() {
	$("html,body").animate({scrollTop:0});
$(this.form).find("textarea, :text, select").val("").end().find(":checked").prop("checked", false);

$('td').removeClass('thissize');
$('td').removeClass('thisselect');
});
